// Packages
import { useEffect } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Utils
import domUtil from "lib/dom/dom-util"

// tracking
import TC from "components/Stacker/constants/TrackingConstants"

import { addtoDataLayer } from "components/Stacker/utils/DataLayer"

// Actions
import { setCurrentSort } from "components/Stacker/actions/SearchActions"
import { resetPagination } from "components/Stacker/actions/StackerActions"

// Styles
import "./SearchSort.scss"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function SearchSort(props) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  useEffect(() => {
    let prevElem = domUtil.findFirst("li.selected")
    if (prevElem) {
      prevElem = prevElem.previousSibling
      domUtil.addClass(prevElem, "previous")
    }
  }, [])

  // On selection of Sort Order
  const changeSort = (e) => {
    e.preventDefault()
    const { previousSelectedKey, selectedCode, selectedSortName } =
      e.target.dataset
    if (previousSelectedKey !== selectedCode) {
      // Firing ensighten event and updating data layer on changing sort option
      if (selectedSortName && selectedSortName.length) {
        addtoDataLayer(TC.LAYER_SELECTED_SORT, selectedSortName)
      }
      dispatch(resetPagination())
      dispatch(setCurrentSort(selectedCode))
    }

    // Don't call the method explicityly as it gets called due to bubbling by default
    // and calling again will toogle the status
    // const { handleToggleSortView } = this.props;
    // handleToggleSortView(e);
  }

  const {
    searchSort,
    selectedSort = "low_price asc",
    handleToggleSortView,
    isSortViewExpanded,
  } = props

  if (searchSort.length === 0) {
    return false
  }
  const filteredSorts = searchSort.filter(
    (sortItem) => sortItem.code === selectedSort
  )
  const selectedSortValue = filteredSorts.length ? filteredSorts : searchSort

  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  return (
    <div className="SearchSort">
      <ul
        className={classNames("sortlist-dropdown", {
          expanded: isSortViewExpanded,
        })}
        onMouseEnter={handleToggleSortView}
        onMouseLeave={handleToggleSortView}
        onClick={handleToggleSortView}
        role="menu"
      >
        <li className="sortlst-header" role="menuitem">
          <button className="text-black" aria-expanded={isSortViewExpanded}>
            {LL.search.sortText()}{" "}
            <span className="selected-sort-text text-black">
              {selectedSortValue[0]?.name}
            </span>
            <span className="caret" />
          </button>
          <hr />
        </li>
        {isSortViewExpanded &&
          searchSort.map((sortItem) => (
            <li
              className={classNames("sortlist-li", {
                selected: selectedSortValue[0].code === sortItem.code,
              })}
              key={sortItem.code}
              role="menuitem"
            >
              <button
                className="sortlist-btn text-black"
                data-selected-code={sortItem.code}
                data-previous-selected-key={selectedSortValue[0].code}
                data-selected-sort-name={sortItem.name}
                onClick={changeSort}
              >
                {sortItem.name}
              </button>
            </li>
          ))}
      </ul>
    </div>
  )
}

SearchSort.propTypes = {
  searchSort: PropTypes.array.isRequired,
  handleToggleSortView: PropTypes.func,
  selectedSort: PropTypes.string.isRequired,
  isSortViewExpanded: PropTypes.bool.isRequired,
}

export default SearchSort
